import { useReactQuery } from '@flik/shared/api';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const InvitationRedirectHandler: React.FC = () => {
  const { invitationToken } = useParams<{ invitationToken: string }>();
  const navigate = useNavigate();
  const apiClient = useReactQuery();

  // Fetch invitation details to get session ID
  const fetchInvitation = apiClient.useQuery(
    'get',
    '/v1/sessions/invitations/{invitation_id}',
    {
      params: {
        path: {
          invitation_id: invitationToken ?? '',
        },
      },
    },
    {
      enabled: !!invitationToken,
    },
  );

  useEffect(() => {
    if (fetchInvitation.data?.invitation?.session_id) {
      // Redirect to the session page
      navigate(`/sessions/${fetchInvitation.data.invitation.session_id}`, {
        replace: true,
      });
    } else if (fetchInvitation.error) {
      // If invitation is invalid, redirect to home with error
      navigate('/', { replace: true });
    }
  }, [fetchInvitation.data, fetchInvitation.error, navigate]);

  // Show loading state while redirecting
  return (
    <div className="w-full min-h-screen flex items-center justify-center bg-black text-white">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink-600 mx-auto mb-4"></div>
        <p>Redirecting to session...</p>
      </div>
    </div>
  );
};

export default InvitationRedirectHandler;
